module.exports = __webpack_public_path__ + "static/media/new_logotipo-talisis.9eb911ab.svg";